import { Link } from "react-router-dom";
import { movies } from "@/mocks/movies";

export default function HeroSection() {
  const featuredMovie = movies.find((m) => m.id === "movie-7") || movies[6];

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src={featuredMovie.backdropUrl}
        alt="光棍影院 - 免费高清电影在线观看"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/70"></div>

      <div className="absolute inset-0 flex flex-col items-center justify-center text-center w-full px-4 md:px-6">
        <div className="max-w-3xl">
          <h1 className="text-3xl md:text-5xl font-bold text-white mb-4 leading-tight" style={{ fontFamily: "var(--font-heading)" }}>
            光棍影院
          </h1>
          <p className="text-base md:text-lg text-white/80 mb-8 max-w-xl mx-auto">
            电影大全收录最新电影免费高清资源，动作片喜剧片等海量免费影视在线观看，经典大片随时畅享
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/action"
              className="px-6 py-3 bg-primary-500 text-white rounded-md font-semibold text-sm whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
            >
              立即观影
            </Link>
            <Link
              to="/about"
              className="px-6 py-3 bg-white/10 text-white border border-white/30 rounded-md font-semibold text-sm whitespace-nowrap hover:bg-white/20 transition-colors cursor-pointer"
            >
              了解更多
            </Link>
          </div>
          <div className="flex items-center justify-center gap-6 mt-8">
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-bold text-accent-400">{movies.length}+</p>
              <p className="text-xs text-white/60">高清影片</p>
            </div>
            <div className="w-px h-10 bg-white/20"></div>
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-bold text-accent-400">8</p>
              <p className="text-xs text-white/60">电影分类</p>
            </div>
            <div className="w-px h-10 bg-white/20"></div>
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-bold text-accent-400">100万+</p>
              <p className="text-xs text-white/60">日活用户</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}